import { useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { QualityContext } from "../contexts/quality-context";
import { qualityOptions } from "../utils/chord-lookup";

const QualityDropdown = () => {
  const { qualityValue, dispatch } = useContext(QualityContext);
  return (
    <Dropdown>
      <Dropdown.Toggle className="glass-btn">
        {qualityValue}
      </Dropdown.Toggle>
      <Dropdown.Menu className="scrollable-menu">
        {qualityOptions.map((value) => {
          return (
            <Dropdown.Item
              as="button"
              key={value}
              value={value}
              onClick={() => {
                dispatch({ type: "QUALITY", qualityValue: value });
              }}
            >
              {value}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default QualityDropdown;
